// import EditProfileContainer from "../../../../Component/Application/Users/EditProfile/EditProfile"
import EditProfileContainer from '../../../../Component/Application/Users/Detail';

const EditProfile = ({ user_type_id }: { user_type_id: string }) => {
    return (
        <div className="page-body">
            <EditProfileContainer user_type_id={user_type_id} />
        </div>
    );
};

export default EditProfile;
